import invoiceModule from '../module'
import invoiceDiscountPage from '../view/invoiceDiscount.html'
import Goods from '../model/Goods'
import { calculateTax, globalFn, toFixed } from '../invoiceUtils'

// 是否正确折扣率
function isDiscountRate(v) {
    const regNum = /^\d{1,4}(\.\d{0,6})?$/ // 金额规则 数字，小数点前4位，后6位
    return globalFn.isPositiveFloatNum(v) && v !== 0 && regNum.test(v)
}
// 是否正确的金额
function isAmount(v) {
    const regAmount = /^\d{1,12}(\.\d{0,2})?$/ // 金额规则 数字，小数点前12位，后2位
    return globalFn.isPositiveFloatNum(v) && v !== 0 && regAmount.test(v)
}

class modalDiscountCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger) {
        $scope.modaldata = items1

        $scope.discountRateChange = function discountRateChange() {
            if (!$scope.modaldata.discountRate && $scope.modaldata.discountRate !== 0) {
                return
            }
            if (!isDiscountRate($scope.modaldata.discountRate)) {
                $scope.modaldata.discountRate = ''
                logger.logError('折扣率整数部分不能大于4个数字，小数部分不能大于6个数字')
                return
            }
            if ($scope.modaldata.discountRate <= 0 || $scope.modaldata.discountRate > 100) {
                logger.logError('折扣率大于0，小于等于100')
                return
            }
            const discountAmt = globalFn.Mul($scope.modaldata.totalAmt, globalFn.Div($scope.modaldata.discountRate, 100))
            $scope.modaldata.discountAmt = toFixed(discountAmt, 2)
        }

        $scope.discountAmtChange = function discountAmtChange() {
            if (!$scope.modaldata.discountAmt) {
                return
            }
            if (!isAmount($scope.modaldata.discountAmt)) {
                $scope.modaldata.discountAmt = ''
                logger.logError('金额整数部分不能大于12个数字，小数部分不能大于2个数字')
                return
            }

            if (globalFn.Sub(globalFn.Sub($scope.modaldata.totalAmt, $scope.modaldata.balance), $scope.modaldata.discountAmt) < 0) {
                logger.logError('折扣金额不能大于商品金额')
                return
            }
            const discountRate = globalFn.Mul(100, globalFn.Div($scope.modaldata.discountAmt, $scope.modaldata.totalAmt))
            $scope.modaldata.discountRate = toFixed(discountRate, 6)
        }

        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }

        $scope.ok = function ok() {
            // 返回数据
            if (!isDiscountRate($scope.modaldata.discountRate) || !isAmount($scope.modaldata.discountAmt)) {
                $scope.modaldata.discountRate = ''
                logger.logError('折扣信息有误！')
                return
            }
            if ($scope.modaldata.discountRate <= 0 || $scope.modaldata.discountRate > 100) {
                logger.logError('折扣率大于0，小于等于100')
                return
            }
            if (globalFn.Sub(globalFn.Sub($scope.modaldata.totalAmt, $scope.modaldata.balance), $scope.modaldata.discountAmt) < 0) {
                logger.logError('折扣金额不能大于商品金额')
                return
            }
            $uibModalInstance.close($scope.modaldata)
        }
    }
}

modalDiscountCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger']
invoiceModule.controller('modalDiscountCtrl', modalDiscountCtrl)
invoiceModule.directive('invoiceDiscount', ['logger', '$uibModal', '$rootScope', (logger, $uibModal, $rootScope) => ({
    scope: {
        invoice: '<',
        selectedRows: '<',
    },
    template: `
        <button class="btn btn-primary btn-xs"
            ng-class="{'btn-disabled':isBtnDisable()}"
         ng-click="openDiscountDialog()">折扣</button>
    `,

    link(scope) {
        const bindings = scope
        function goodsCanDiscount(goods) {
            if (!goods.selected) {
                return false
            }
            if (goods.lineNature === '1' || !isAmount(goods.amount)) {
                return true
            }
            return false
        }
        bindings.isBtnDisable = function isBtnDisable() {
            if (!bindings.invoice) return false
            if (!bindings.selectedRows.length) return true
            for (let i = 0; i < bindings.invoice.details.length; i++) {
                if (goodsCanDiscount(bindings.invoice.details[i])) {
                    return true
                }
            }
            return false
        }
        bindings.openDiscountDialog = function openDiscountDialog() {
            // 获取选中的商品对象列表， checkall组件绑定的是serialNo
            if (bindings.isBtnDisable()) {
                return
            }
            if (bindings.selectedRows.length === 0) {
                logger.logError('请先选择商品行')
                return
            }
            const { invoice } = bindings
            // 【ID1024812】【专票清单】手工新增专票，第9行或者第9行以上是折扣行时，开票失败

            // if (invoice.details.length + bindings.selectedRows.length > invoice.getMaxRow()
            //     && (invoice.isRed === '1' || invoice.invType === '0')) {
            //     logger.logError('商品明细行最多8行, 添加折扣行后会超出限制，请重新选择')
            //     return
            // }
            let totalAmount = 0
            for (let i = 0; i < bindings.selectedRows.length; i++) {
                const selectedSeriaNo = bindings.selectedRows[i]
                for (let j = 0; j < invoice.details.length; j++) {
                    const goods = invoice.details[j]
                    if (goods.serialNo === selectedSeriaNo) {
                        if (goods.lineNature === '1') {
                            logger.logError('折扣行不允许添加折扣')
                            return
                        }
                        if (!goods.amount) {
                            logger.logError('请填写正确的商品金额')
                            return
                        }
                        if (invoice.isTax === '1') {
                            totalAmount = globalFn.Add(totalAmount, goods.adValoremTotal)
                        } else {
                            totalAmount = globalFn.Add(totalAmount, goods.amount)
                        }
                        break
                    }
                }
            }
            const discountModalData = {
                totalAmt: totalAmount,
                balance: bindings.invoice.details[0].$balance || 0,
            } // 数据
            const modalInstance = $uibModal.open({
                template: invoiceDiscountPage,
                controller: 'modalDiscountCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
                resolve: {
                    items1() {
                        return discountModalData
                    },
                },
            })
            modalInstance.result.then((item) => {
                const { details } = bindings.invoice
                // 新的详情数组
                const newDetails = []
                // 折扣率
                const discountRate = globalFn.Div(item.discountRate, 100)
                for (let j = 0; j < details.length; j++) {
                    const goods = details[j]
                    if (goods.selected) {
                        goods.selected = false
                        goods.discountRate = discountRate
                        goods.serialNo = newDetails.length + 1
                        newDetails.push(goods)
                        const discountGoods = new Goods()
                            .fromInvoiceDetail(goods, bindings.invoice.invType)
                            .toDiscountGoods(discountRate, bindings.invoice.isTax)
                        discountGoods.serialNo = newDetails.length + 1
                        newDetails.push(discountGoods)
                        if (details[j + 1] && details[j + 1].lineNature === '1') {
                            j += 1
                        }
                    } else {
                        goods.serialNo = newDetails.length + 1
                        newDetails.push(goods)
                    }
                }
                bindings.invoice.details = newDetails
                $rootScope.$broadcast('openGoodsDialog')
            })
        }
    },
})])



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/invoiceDiscount.js